// extracted by mini-css-extract-plugin
export default {"wrap":"StickyGallery_wrap__WV4Xp","body":"StickyGallery_body__UcgBn","inner":"StickyGallery_inner__wBhfj","col":"StickyGallery_col__dedqg"};